import React from 'react';
import { Link } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const PageFooter = ({ classes }) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  function handlePolicyClick() {
    window.open(`/manuals/${i18n.language}/policy.pdf`);
    return false;
  }

  return (
    <div className={classes.footer}>
      <Toolbar className={classes.toolbar}>
        <Typography variant="caption" className={classes.link}>
          <a href="#" onClick={handlePolicyClick}>
            {t('terms_and_conditions')}
          </a>
        </Typography>
        <Typography variant="caption" className={classes.link}>
          <Link to="/about">{t('about_us')}</Link>
        </Typography>
        <Typography variant="caption" className={classes.link}>
          <Link to="/contacts">{t('contacts')}</Link>
        </Typography>
      </Toolbar>
    </div>
  );
};
/*
<div className={classes.paylogo}>
  <img src="/visa-pay-logo.svg" />
  <img src="/master-card-logo.svg" />
</div>
*/
const styles = (theme) => {
  const colors = theme.palette.custom.pageHeader;
  return {
    footer: {
      backgroundColor: theme.palette.custom.pageFooter,
      minHeight: '36px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        minHeight: '24px',
      },
    },
    toolbar: {
      flex: '1 0 0px',
      justifyContent: 'space-between',
    },
    name: {
      color: theme.palette.custom.logo,
      marginLeft: theme.spacing.unit,
    },
    paylogo: {
      display: 'flex',
      alignItems: 'center',
      '& > img': {
        height: '40px',
      },
      [theme.breakpoints.down('xs')]: {
        '& > img': {
          height: '20px',
        },
      },
    },
    address: {
      color: theme.palette.custom.logo,
      fontWeight: 'normal',
    },
    link: {
      fontWeight: 'normal'
    },
  };
};

export default withStyles(styles)(PageFooter);
